import { TooltippedSpan } from '@mews-commander/ui';
import { LocalizedText, useDialogAction } from '@mews/framework';
import { IconName, TableBulkActionButton } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { PortfolioRateOverview } from '@mews-commander/data-access';
import { CreateVoucherFromRatesContainer } from '../../sections/components/vouchers/CreateVoucherFromRatesContainer';
import { CREATE_VOUCHER_STARTING_POINT } from '../../../utilities/userFlowTestIds';
import { getBulkAddVoucherVariables } from './getBulkAddVoucherVariables';

interface BulkVoucherAddProps {
    selectedRows: PortfolioRateOverview[];
    resetRowSelection: () => void;
}

export const BulkAddVoucher = ({ selectedRows, resetRowSelection }: BulkVoucherAddProps) => {
    const { states, handlers } = useDialogAction(async () => Promise.resolve());

    const { isVoucherAddDisabled, groupedSelectedRows } = getBulkAddVoucherVariables(selectedRows);

    return (
        <>
            <TooltippedSpan
                tooltip={
                    isVoucherAddDisabled && <LocalizedText textKey={TextKey.NoPublicAndNullishRateKeyTooltipHint} />
                }
            >
                <TableBulkActionButton
                    data-test-id={CREATE_VOUCHER_STARTING_POINT}
                    icon={IconName.Add}
                    onClick={handlers.handleOpen}
                    disabled={isVoucherAddDisabled}
                >
                    <LocalizedText textKey={TextKey.CreateVoucher} />
                </TableBulkActionButton>
            </TooltippedSpan>
            {states.isDialogOpened && (
                <CreateVoucherFromRatesContainer
                    isOpened={states.isDialogOpened}
                    onConfirm={async () => {
                        await handlers.handleConfirm();
                        resetRowSelection();
                    }}
                    onCancel={handlers.handleCancel}
                    groupedRateKeys={groupedSelectedRows}
                />
            )}
        </>
    );
};
